import moment from 'moment'

export function formatDate (date) {
  return moment(date).format('DD/MM/Y')
}

export function formatDateHour (date) {
  return moment(date).format('DD/MM/Y H:m')
}

export function formatHour (date) {
  return moment(date).format('HH:mm')
}
